var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelfav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 96,
    viewBox: "0 0 93 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_188_20612)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.6719,
    y: 25.5,
    width: 40,
    height: 40,
    rx: 7.61905,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_20612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 35,
    width: 22,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.9524,
    height: 20.9524,
    transform: "matrix(-1 0 0 1 63.1484 35.0234)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_20612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7675 52.9221C57.2029 52.9221 57.5748 52.7679 57.8833 52.4596C58.1916 52.1511 58.3457 51.7792 58.3457 51.3439V40.2633H59.2188V38.9538H55.2902V38.1816H50.0521V38.9538H46.1235V40.2633H46.9965V51.3439C46.9965 51.7849 47.1493 52.1582 47.4549 52.4637C47.7604 52.7693 48.1337 52.9221 48.5747 52.9221H56.7675ZM48.3061 40.2633H57.0362V51.3439C57.0362 51.4223 57.011 51.4867 56.9607 51.537C56.9104 51.5874 56.846 51.6126 56.7675 51.6126H48.5747C48.5075 51.6126 48.446 51.5845 48.3901 51.5285C48.3341 51.4727 48.3061 51.4111 48.3061 51.3439V40.2633ZM54.9375 49.8665H53.6282V42.0094H54.9375V49.8665ZM51.7141 49.8665H50.4048V42.0094H51.7141V49.8665Z",
    fill: "#F43030"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_188_20612",
    x: 0.290923,
    y: 0.738096,
    width: 97.1429,
    height: 97.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.80952,
    dy: 3.80952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_188_20612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_188_20612",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelfav);
export default __webpack_public_path__ + "static/media/delfav.59442b15bc8ed1cbe78d118a5d8f8abf.svg";
export { ForwardRef as ReactComponent };